import moment from 'moment';

export const time = val => moment(val).format('hh:mm a');
export const getDate = val => moment(val).format('DD/MM/YYYY');

export const getDateTime = val => `${getDate(val)} | ${time(val)}`;
export const getMonthName = val => moment(val).format('MMMM');
export const getFullDate = val => {
  let month = moment(val).format('MMMM');
  let day = moment(val).format('D');
  let year = moment(val).format('YYYY');

  return `${month} ${day}, ${year}`;
};
// Capitalize Text
export const capitalize = str => {
  return str.replace(/\w\S*/g, t => {
    return t.charAt(0).toUpperCase() + t.substr(1).toLowerCase();
  });
};
// check if url is valid
export const isValidWebUrl = url => {
  let regEx =
    /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/gm;
  return regEx.test(url);
};
